import { Link } from "react-router-dom"

const styles = `
           @layer base {
            body {
                @apply bg-background-light dark:bg-background-dark text-slate-800 dark:text-slate-200 font-sans transition-colors duration-300;
            }
        }
        .error-glow {
            background: radial-gradient(circle at center, rgba(249, 115, 22, 0.1) 0%, transparent 70%);
        }
`;

export const NotFound = () => {
    return (
        <>

            <style type="text/tailwindcss">{styles}</style>

            <main class="relative w-full px-2 py-4 text-center z-10">
                <div class="absolute inset-0 flex items-center justify-center -z-10 opacity-[0.03] dark:opacity-[0.05]">
                    <span class="material-symbols-outlined text-[20rem] md:text-[30rem] select-none">search_off</span>
                </div>
                <div class="space-y-4">
                    <div class="flex justify-center items-center gap-3 mb-2">
                        <div class="font-display font-bold text-5xl" style={{ color: 'rgb(242, 109, 33)' }}>FJ</div>
                        <div class="text-left">
                            <span
                                class="font-display text-2xl font-bold tracking-tighter text-slate-900 dark:text-white uppercase leading-none block">Flacon
                                Jeans</span>
                            <p class="text-[10px] uppercase tracking-[0.2em] font-semibold text-primary">Since 2007</p>
                        </div>
                    </div>
                    <div class="relative inline-block">
                        <span
                            class="material-symbols-outlined text-primary text-7xl md:text-8xl opacity-80 mb-4 block">warning</span>
                        <div class="error-glow absolute inset-0 -m-20 pointer-events-none"></div>
                    </div>
                    <div class="space-y-2">
                        <h1
                            class="text-5xl md:text-7xl font-display font-bold text-slate-900 dark:text-white uppercase tracking-tight">
                            Lost in the <span class="text-primary">Weave</span>
                        </h1>
                        <p class="text-slate-500 dark:text-slate-400 font-semibold uppercase tracking-[0.2em] text-sm">
                            Error 404: The thread you are following has snapped.
                        </p>
                    </div>
                    <p class="text-slate-600 dark:text-slate-400 max-w-md mx-auto leading-relaxed">
                        The page you are looking for might have been moved, removed, or is temporarily unavailable in our
                        current collection.
                    </p>
                    <div class="pt-4">
                        <Link class="inline-block bg-primary hover:bg-orange-600 text-white px-10 py-4 rounded font-display font-bold uppercase text-lg tracking-widest transition-all shadow-lg hover:shadow-primary/20 active:scale-95"
                            to="/">
                            Return to Homepage
                        </Link>
                    </div>
                    {/* <div class="pt-12">
                        <button class="p-3 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
                            onclick="document.documentElement.classList.toggle('dark')">
                            <span class="material-symbols-outlined text-2xl">dark_mode</span>
                        </button>
                    </div> */}
                </div>
            </main>
            <div class="fixed top-0 left-0 w-full h-1 bg-primary/10">
                <div class="w-1/3 h-full bg-primary"></div>
            </div>
        </>
    )
}